import React from 'react';

import { Description, LediumForm, ShowIntensityValue, TitleAndDescription, UniqueName } from '@ledium/ui-common';
import { LightChannelChart } from '@ledium/ui-light-channels';
import { Container } from '@mui/material';

import LightRecipesCsvUpload from './Components/LightRecipesCsvUpload';

interface LightRecipesViewProps {
    onSave: () => void;
    onClose: () => void;
}

const LightRecipesView = ({ onSave, onClose }: LightRecipesViewProps) => (
    <Container>
        <LediumForm onSubmit={() => onSave()} onCancel={onClose} header={<TitleAndDescription />}>
            <UniqueName />
            <Description />
            <ShowIntensityValue />
            <LightRecipesCsvUpload />
            <LightChannelChart />
        </LediumForm>
    </Container>
);

export default LightRecipesView;
